<!-- Header that allows for selecting the Infrastructure subpage to be on -->
<app-infrastructure-header [title]='"ANTENNAS"'></app-infrastructure-header>

<!-- Main Screen which shows the Antennas and Antenna Instances -->
<div style="clear: both" id="objectContentPane">
	<div style="margin: 12px">

		<!-- Tab Navigation Control -->
		<ul class="nav nav-tabs">
			<li class="active"><a data-toggle="tab" href="#antenna-instances-tab" aria-expanded="true"><i
						class="fa fa-star-o"></i> ANTENNAS</a></li>
			<li class=""><a data-toggle="tab" href="#antennas-tab" aria-expanded="false"><i class="fa fa-star-o"></i>
					ANTENNA TYPES</a></li>
		</ul>

		<!-- Tab Content -->
		<div class="tab-content">

			<!-- Antennas Tab -->
			<div id="antennas-tab" class="tab-pane fade">

				<!-- Add Antenna Type and Options buttons -->
				<button (click)="addAntennaClicked()" type="button" class="btn btn-ef"><em class="fa fa-plus"></em> ADD
					ANTENNA TYPE</button>
				<div class="dropdown btn-group edgefinityHeader" style="display:inline-block">
					<button type="button" class="btn btn-ef dropdown-toggle" data-toggle="dropdown"><em
							class="fa fa-th"></em> OPTIONS <span class="caret"></span></button>
					<ul class="dropdown-menu">
						<li (click)="editSelectedAntennaClicked()" [class.disabled]="!isSingleAntennaSelected()"><a><em
									class="fa fa-pencil"></em> EDIT</a></li>
						<li (click)="duplicateSelectedAntennaClicked()" [class.disabled]="!isSingleAntennaSelected()">
							<a><em class="fa fa-clone"></em> DUPLICATE</a></li>
						<li (click)="deleteSelectedAntennasClicked()" [class.disabled]="!isAnyAntennasSelected()"><a><em
									class="fa fa-remove"></em> DELETE</a></li>
						<li class="divider"></li>
						<li (click)="addSelectedAntennasToGroupClicked()" [class.disabled]="!isAnyAntennasSelected()">
							<a><em class="fa fa-plus"></em> ADD TO GROUP</a></li>
						<li (click)="removeSelectedAntennasFromGroupClicked()"
							[class.disabled]="!isAnyAntennasSelected()"><a><em class="fa fa-remove"></em> REMOVE FROM
								GROUP</a></li>
						<li (click)="manageAntennaGroupsClicked()"><a><em class="fa fa-pencil"></em> MANAGE GROUPS</a>
						</li>
					</ul>
				</div>

				<!-- "Filter" Button w/ drop down options -->
				<div class="dropdown btn-group edgefinityHeader" style="display:inline-block">
					<button type="button" class="btn btn-ef dropdown-toggle" data-toggle="dropdown">
						<em class="fa fa-filter"></em> FILTER <span class="caret"></span>
					</button>
					<ul class="dropdown-menu">
						<li *ngFor="let filterOption of filterOptionForAntenna"
							(click)="onFilterOptionForAntennaClicked(filterOption)">
							<a>{{ filterOption.label }}</a>
						</li>
					</ul>
				</div>

				<!-- Filter Label (if a Filter Option is selected) -->
				<div *ngIf="selectedFilterOptionForAntenna?.column != null" class="dropdown btn-group edgefinityHeader"
					style="display:inline-block">
					{{ selectedFilterOptionForAntenna.label }}
				</div>

				<!-- Filter Value (if a Filter Option is selected)-->
				<div *ngIf="selectedFilterOptionForAntenna?.column != null" class="dropdown btn-group edgefinityHeader"
					style="display:inline-block">
					<input class="form-control ng-pristine ng-valid ng-untouched" type="text"
						[(ngModel)]="filterOptionValueForAntenna" (ngModelChange)="onFilterValueForAntennaChanged()">
				</div>

				<div class="dropdown btn-group edgefinityHeader" style="display:inline-block">
					<button type="button" class="btn btn-ef dropdown-toggle" data-toggle="dropdown"><em
							class="fa fa-bars"></em> RESULTS PER PAGE <span class="caret"></span></button>
					<ul class="dropdown-menu">
						<li *ngFor="let value of resultsPerPageValues"
							(click)="manageResultPerPageClickedForTypes(value)"
							[class.active]="value === selectedPageSizeValueForTypes">
							<a>{{ value }}</a>
						</li>
					</ul>
				</div>

				<!-- Antennas -->
				<table class="table tablesorter tablesorter-default table-bordered table-hover" data-toggle="table"
					data-id-field="userid" role="grid">
					<thead>
						<tr role="row" class="tablesorter-headerRow">
							<th data-column="0" class="tablesorter-header tablesorter-headerUnSorted" tabindex="0"
								scope="col" role="columnheader" aria-disabled="false" aria-controls="table1"
								aria-sort="none" aria-label=": No sort applied, activate to apply an ascending sort"
								style="user-select: none;">
								<div class="tablesorter-header-inner">
									<input type="checkbox" [checked]="isAllAntennasSelected()"
										(change)="setAllAntennasSelected($event)" />
								</div>
							</th>
							<th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;"
								data-field="name" data-sortable="true" data-column="1" tabindex="0" scope="col"
								role="columnheader" aria-disabled="false" aria-controls="table1" aria-sort="none"
								aria-label="Name: No sort applied, activate to apply an ascending sort">
								<div class="tablesorter-header-inner">Name</div>
							</th>
							<th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;"
								data-field="groups" data-sortable="true" data-column="2" tabindex="0" scope="col"
								role="columnheader" aria-disabled="false" aria-controls="table1" aria-sort="none"
								aria-label="Groups: No sort applied, activate to apply an ascending sort">
								<div class="tablesorter-header-inner">Groups</div>
							</th>
						</tr>
					</thead>
					<tbody aria-live="polite" aria-relevant="all">
						<ng-container *ngFor="let antenna of mAntennas | paginate: { id: 'antennas_pagination',
																							itemsPerPage: selectedPageSizeValueForTypes,
																							currentPage: currentPageForAntenna,
																							totalItems: totalNumberOfAntenna }">
							<tr class="" role="row">
								<td><input type="checkbox" [(ngModel)]="antenna.mSelected" /></td>
								<td (click)="editAntenna(antenna.mAntenna)">{{antenna.mAntenna.name}}</td>
								<td>
									<ng-container
										*ngIf="antenna.mAntenna.groups != null && antenna.mAntenna.groups.length > 0">
										<ng-container *ngFor="let group of antenna.mAntenna.groups">
											<button class="groupButton"
												(click)="showGroup(group)">{{group.name}}</button>
										</ng-container>
									</ng-container>
								</td>
							</tr>
						</ng-container>
					</tbody>
				</table>

				<!-- Pagination Controls for Antenna Types -->
				<pagination-controls class="pagination" id="antennas_pagination"
					(pageChange)="pageChangedAntenna($event)" [directionLinks]="true" nextLabel="Next"
					previousLabel="Prev" [autoHide]="true">
				</pagination-controls>

			</div>

			<!-- Antenna Instances Tab -->
			<div id="antenna-instances-tab" class="tab-pane fade active in">

				<!-- Add Antenna and Options buttons -->
				<button (click)="addAntennaInstanceClicked()" type="button" class="btn btn-ef"><em
						class="fa fa-plus"></em> ADD ANTENNA</button>
				<div class="dropdown btn-group edgefinityHeader" style="display:inline-block">
					<button type="button" class="btn btn-ef dropdown-toggle" data-toggle="dropdown"><em
							class="fa fa-th"></em> OPTIONS <span class="caret"></span></button>
					<ul class="dropdown-menu">
						<li (click)="editSelectedAntennaInstanceClicked()"
							[class.disabled]="!isSingleAntennaInstanceSelected()"><a><em class="fa fa-pencil"></em>
								EDIT</a></li>
						<li (click)="duplicateSelectedAntennaInstanceClicked()"
							[class.disabled]="!isSingleAntennaInstanceSelected()"><a><em class="fa fa-clone"></em>
								DUPLICATE</a></li>
						<li (click)="deleteSelectedAntennaInstancesClicked()"
							[class.disabled]="!isAnyAntennaInstancesSelected()"><a><em class="fa fa-remove"></em>
								DELETE</a></li>
						<li class="divider"></li>
						<li (click)="addSelectedAntennaInstancesToGroupClicked()"
							[class.disabled]="!isAnyAntennaInstancesSelected()"><a><em class="fa fa-plus"></em> ADD TO
								GROUP</a></li>
						<li (click)="removeSelectedAntennaInstancesFromGroupClicked()"
							[class.disabled]="!isAnyAntennaInstancesSelected()"><a><em class="fa fa-remove"></em> REMOVE
								FROM GROUP</a></li>
						<li (click)="manageAntennaInstanceGroupsClicked()"><a><em class="fa fa-pencil"></em> MANAGE
								GROUPS</a></li>
					</ul>
				</div>

				<!-- "Filter" Button w/ drop down options -->
				<div class="dropdown btn-group edgefinityHeader" style="display:inline-block">
					<button type="button" class="btn btn-ef dropdown-toggle" data-toggle="dropdown">
						<em class="fa fa-filter"></em> FILTER <span class="caret"></span>
					</button>
					<ul class="dropdown-menu">
						<li *ngFor="let filterOption of filterOptionForAntennaInstance"
							(click)="onFilterOptionForAntennaInstanceClicked(filterOption)">
							<a>{{ filterOption.label }}</a>
						</li>
					</ul>
				</div>

				<!-- Filter Label (if a Filter Option is selected) -->
				<div *ngIf="selectedFilterOptionForAntennaInstance?.column != null"
					class="dropdown btn-group edgefinityHeader" style="display:inline-block">
					{{ selectedFilterOptionForAntennaInstance.label }}
				</div>

				<!-- Filter Value (if a Filter Option is selected)-->
				<div *ngIf="selectedFilterOptionForAntennaInstance?.column != null"
					class="dropdown btn-group edgefinityHeader" style="display:inline-block">
					<input class="form-control ng-pristine ng-valid ng-untouched" type="text"
						[(ngModel)]="filterOptionValueForAntennaInstance"
						(ngModelChange)="onFilterValueForAntennaInstanceChanged()">
				</div>

				<div class="dropdown btn-group edgefinityHeader" style="display:inline-block">
					<button type="button" class="btn btn-ef dropdown-toggle" data-toggle="dropdown"><em
							class="fa fa-bars"></em> RESULTS PER PAGE <span class="caret"></span></button>
					<ul class="dropdown-menu">
						<li *ngFor="let value of resultsPerPageValues"
							(click)="manageResultPerPageClickedForInstances(value)"
							[class.active]="value === selectedPageSizeValueForInstances">
							<a>{{ value }}</a>
						</li>
					</ul>
				</div>

				<!-- Antenna Instances -->
				<table class="table tablesorter tablesorter-default table-bordered table-hover" data-toggle="table"
					data-id-field="userid" role="grid">
					<thead>
						<tr role="row" class="tablesorter-headerRow">
							<th data-column="0" class="tablesorter-header tablesorter-headerUnSorted" tabindex="0"
								scope="col" role="columnheader" aria-disabled="false" aria-controls="table2"
								aria-sort="none" aria-label=": No sort applied, activate to apply an ascending sort"
								style="user-select: none;">
								<div class="tablesorter-header-inner">
									<input type="checkbox" [checked]="isAllAntennaInstancesSelected()"
										(change)="setAllAntennaInstancesSelected($event)" />
								</div>
							</th>
							<th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;"
								data-field="name" data-sortable="true" data-column="1" tabindex="0" scope="col"
								role="columnheader" aria-disabled="false" aria-controls="table2" aria-sort="none"
								aria-label="Name: No sort applied, activate to apply an ascending sort">
								<div class="tablesorter-header-inner">Name</div>
							</th>
							<th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;"
								data-field="object" data-sortable="true" data-column="2" tabindex="0" scope="col"
								role="columnheader" aria-disabled="false" aria-controls="table2" aria-sort="none"
								aria-label="Asset Type: No sort applied, activate to apply an ascending sort">
								<div class="tablesorter-header-inner">Antenna Type</div>
							</th>
							<th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;"
								data-field="groups" data-sortable="true" data-column="3" tabindex="0" scope="col"
								role="columnheader" aria-disabled="false" aria-controls="table2" aria-sort="none"
								aria-label="Groups: No sort applied, activate to apply an ascending sort">
								<div class="tablesorter-header-inner">Groups</div>
							</th>
						</tr>
					</thead>
					<tbody aria-live="polite" aria-relevant="all">
						<ng-container
							*ngFor="let antennaInstance of mAntennaInstances | paginate: {id: 'antennainstance_pagination', itemsPerPage: selectedPageSizeValueForInstances, currentPage: currentPageForAntennaInstance, totalItems: totalNumberOfAntennaInstance }">
							<tr class="" role="row">
								<td><input type="checkbox" [(ngModel)]="antennaInstance.mSelected" /></td>
								<td (click)="editAntennaInstance(antennaInstance.mAntennaInstance)" (contextmenu)="fetchFunctionList($event, antennaInstance.mAntennaInstance)">
									{{antennaInstance.mAntennaInstance.name}}</td>
								<td (click)="editAntennaInstance(antennaInstance.mAntennaInstance)">
									{{antennaInstance.mAntennaInstance.antenna.name}}</td>
								<td>
									<ng-container
										*ngIf="antennaInstance.mAntennaInstance.groups != null && antennaInstance.mAntennaInstance.groups.length > 0">
										<ng-container *ngFor="let group of antennaInstance.mAntennaInstance.groups">
											<button class="groupButton"
												(click)="showGroup(group)">{{group.name}}</button>
										</ng-container>
									</ng-container>
								</td>
							</tr>
						</ng-container>
					</tbody>
				</table>

				<!-- Pagination controls for "Antenna Instance" -->
				<pagination-controls class="pagination" id="antennainstance_pagination"
					(pageChange)="pageChangedAntennaInstance($event)" [directionLinks]="true" nextLabel="Next"
					previousLabel="Prev" [autoHide]="true">
				</pagination-controls>


			</div>
		</div>
	</div>
</div>

<app-entity-type-dialog #entityTypeDialog [entity]="mEntity" [entityName]="mEntityName" [entityType]="mEntityType"
	[entityTypeName]="mEntityTypeName" (createOrUpdateEvent)="createOrUpdateEntityType()"
	(showGroup)="showGroup($event)">
</app-entity-type-dialog>

<app-entity-instance-dialog #entityInstanceDialog [instance]="mInstance" [instanceName]="mInstanceName"
	[instanceEntityType]="mInstanceEntityType" [instanceType]="mInstanceType" [instanceTypeName]="mInstanceTypeName"
	[availableEntityTypes]="mAvailableEntityTypes" [availableReaders]="mAvailableReaders"
	[selectedReader]="mSelectedReader" (createOrUpdateEvent)="createOrUpdateEntityInstance()"
	(showGroup)="showGroup($event)" (selectedEntityTypeChangedEvent)="selectedEntityTypeChanged($event)"
	(selectedReaderChangedEvent)="selectedReaderChanged($event)" (refreshInstanceDataEvent)="refreshInstanceData()">
</app-entity-instance-dialog>

<app-confirm-delete-dialog #confirmDeleteDialog (confirmEvent)="deleteConfirmed()"></app-confirm-delete-dialog>
<app-show-group-dialog #showGroupDialog></app-show-group-dialog>
<app-manage-groups-dialog #manageGroupsDialog></app-manage-groups-dialog>
<app-add-to-group-dialog #addToGroupDialog (confirmEvent)="addSelectedToGroup($event)"></app-add-to-group-dialog>
<app-remove-from-group-dialog #removeFromGroupDialog
	(confirmEvent)="removeSelectedFromGroup($event)"></app-remove-from-group-dialog>

<!-- Right Click dropdown menu -->
<app-dropdown-menu *ngIf="showContextMenu" [x]="contextMenuPosition.x" [y]="contextMenuPosition.y"
	[items]="functionList" (selectedItemChange)="onItemClicked($event)"></app-dropdown-menu>

<!-- Going further if we want to display the function execution status
	<app-function-executing-dialog  #functionExecutingDialog (functionExecutionStartEvent)="functionStartingToExecute($event)" (functionExecutionSuccessEvent)="functionFinishedExecutingSuccessfully()" (functionExecutionErrorEvent)="functionFinishedExecutingWithError($event)"></app-function-executing-dialog> -->

<app-general-function-dialog *ngIf="showGeneralDialog" #generalDialog [instance]="mInstance" [instanceType]="mInstanceType"
	[function]="selectedFunction"></app-general-function-dialog>

<!-- Simple Success Error Dialog Box - Displaying the Error generated for now since we dont display success msgs -->
<ef-simple-success-error-dialog-box #successErrorDialog></ef-simple-success-error-dialog-box>